import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { pageWrapperStyle } from '../../styles/pageStyles.js';
import './PolicyPage.css';

const CampaignResearchTool = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Digital Fig Campaign Research Tool';

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <motion.main
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      style={{ ...pageWrapperStyle, backgroundColor: 'var(--alt-background)' }}
    >
      <section className="policy-page section">
        <div className="container">
          <div className="policy-content">
            <h1>Digital Fig Campaign Research Tool</h1>

            <p>
              This is an internal Digital Fig tool for UK keyword planning and
              read-only campaign reporting on Digital Fig's own advertising
              accounts. With permission, it reads Google Ads campaign and
              keyword data only to research UK keywords and display campaign
              performance reports; it does not create, edit, or delete
              campaigns.
            </p>

            <p>
              For more information about how Digital Fig handles data and the
              rules that apply when using our website, please read our{' '}
              <Link to="/privacy-policy">Privacy Policy</Link> and{' '}
              <Link to="/terms-conditions">Terms &amp; Conditions</Link>.
            </p>
          </div>
        </div>
      </section>
    </motion.main>
  );
};

export default CampaignResearchTool;
